import { render, staticRenderFns } from "./WorkoutPage.vue?vue&type=template&id=b07fd8d4&"
import script from "./WorkoutPage.vue?vue&type=script&lang=js&"
export * from "./WorkoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports